var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Combined Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    transform: "translate(-983.000000, -15.000000)",
    fill: "#EBEAE4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M987.411269,15.8979438 L995.031223,23.5174466 L1002.65118,15.8979438 C1003.65317,14.8959476 1005.27773,14.8959476 1006.27973,15.8979438 C1007.28172,16.89994 1007.28172,18.5244969 1006.27973,19.5264931 L998.660223,27.1464466 L1006.27973,34.7664001 C1007.28172,35.7683964 1007.28172,37.3929532 1006.27973,38.3949494 C1005.27773,39.3969457 1003.65317,39.3969457 1002.65118,38.3949494 L995.031223,30.7754466 L987.411269,38.3949494 C986.409273,39.3969457 984.784716,39.3969457 983.78272,38.3949494 C982.780724,37.3929532 982.780724,35.7683964 983.78272,34.7664001 L991.402223,27.1464466 L983.78272,19.5264931 C982.780724,18.5244969 982.780724,16.89994 983.78272,15.8979438 C984.784716,14.8959476 986.409273,14.8959476 987.411269,15.8979438 Z",
    id: "Combined-Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuClose);
export default __webpack_public_path__ + "static/media/menu-close.bbc704e9414a0cbc85e5728f6864df73.svg";
export { ForwardRef as ReactComponent };